import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import _range from 'lodash/range';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItemCheckbox } from 'components/Dropdown2';

// Use a static array o durations instead of using
// a backend array provided by MSI [CORE-3248]
const MIN_DURATION_IN_MINUTES = 5;
const MAX_DURATION_IN_MINUTES = 240;
const DURATION_STEP = 5;

const messages = defineMessages({
  label: {
    id: 'schedules.duration-filter.label',
    defaultMessage: 'Duration',
  },
  selectedDurations: {
    id: 'schedules.duration-filter.selected-durations',
    defaultMessage: '{durations} minutes',
  },
});

const ScheduleBoardDurationFilter = ({ selectedDurations, updateSelection }) => {
  const intl = useIntl();

  const durations = _range(MIN_DURATION_IN_MINUTES, MAX_DURATION_IN_MINUTES, DURATION_STEP).map(element => ({
    value: element,
    label: element,
  }));

  return (
    <Dropdown
      autocomplete
      multiselect
      closeOnSelect={false}
      selectedOption={{
        label:
          selectedDurations.length > 0
            ? intl.formatMessage(messages.selectedDurations, {
                durations: selectedDurations.join(', '),
              })
            : intl.formatMessage(messages.label),
      }}
      dataCypress="schedule-board-durations-filter"
      options={durations}>
      <DropdownToggle placeholder={messages.label} />
      <DropdownMenu>
        {data =>
          data.map(({ option, isHighlighted, ref }) => {
            const { label, value } = option;
            return (
              <DropdownItemCheckbox
                label={label}
                ref={ref}
                key={value}
                onClick={checked => {
                  const updatedArr = checked
                    ? selectedDurations.concat(value)
                    : selectedDurations.filter(opt => opt !== value);
                  updateSelection(updatedArr);
                }}
                isChecked={selectedDurations.includes(value)}
                isHighlighted={isHighlighted}>
                {label}
              </DropdownItemCheckbox>
            );
          })
        }
      </DropdownMenu>
    </Dropdown>
  );
};

ScheduleBoardDurationFilter.propTypes = {
  updateSelection: PropTypes.func,
  selectedDurations: PropTypes.arrayOf(PropTypes.number),
};

export default ScheduleBoardDurationFilter;
